import { Crown } from 'lucide-react';

export function ZangiaPlusAvatarCrown() {
  return (
    <span
      className="pointer-events-none absolute bottom-0 right-0 flex h-4 w-4 items-center justify-center rounded-full bg-primary-700 text-white ring-2 ring-white"
      aria-hidden
    >
      <Crown className="h-2.5 w-2.5" />
    </span>
  );
}
